import React, { useEffect, useState } from "react";
import Select from 'theme/Select';
import Text from "theme/Text";
import _ from "lodash";
import i18n from "utils/i18n";
import HelperString from 'utils/helper-string'
import { ThemedSelectStyles } from 'styles/components/atoms/ThemedSelect'
import HelperTestID from 'utils/HelperTestID'
import isEqual from 'react-fast-compare'
import { StyleSheet, View } from 'react-native'
import HStack from 'components/atoms/stack/HStack'
import ThemedTimePicker from 'components/atoms/ThemedTimePicker'
import VStack from 'components/atoms/stack/VStack'
import HelperTimeslotKinds from 'utils/helper-timeslot-kinds'
import ThemedSelect from "components/atoms/ThemedSelect";

const ThemedTimeslotTimeSelect = ({ style = {}, options = {}, selected, select, placeholder, disabled = false, label, caption, testID = null }) => {
	
	const [ row, setRow ] = useState( 0 )
	const [ option, setOption ] = useState( null )
	const [ time1, setTime1 ] = useState( null )
	const [ time2, setTime2 ] = useState( null )
	
	if( typeof placeholder === 'undefined' ) {
		placeholder = i18n.t('form.select.placeholder')
	}
	
	const findSelectedOption = () => {
		if( selected ) {
			const extracted = HelperTimeslotKinds.extractUntilTime( selected )
			
			const selectedOptionKey = _.findKey( options, o => {
				return o.value === extracted?.original?.key
			} );
			
			// Get the option
			const selectedOption = selectedOptionKey !== undefined ? options[ selectedOptionKey ] : null;
			
			if( selectedOption !== null ) {
				setOption( selectedOption.value )
				
				// And the time?
				setTime1( extracted?.original?.time1 ?? null )
				setTime2( extracted?.original?.time2 ?? null )
			}
		}
	}

	const onSelect = ( value ) => {
		setOption( value )
	}
	
	const onSelectTime1 = ( time ) => {
		setTime1( time )
	}

	const onSelectTime2 = ( time ) => {
		setTime2( time )
	}
	
	const onSubmit = () => {
		if( !option ) {
			// return;
		}


		// Create the value
		let updatedValue = `${ option }:[${ time1 ?? '' }]:[${ time2 ?? '' }]`;
		if( option === null ) {
			updatedValue = null;
		}
		
		// Submit the value
		if( _.isFunction( select ) ) {
			select( updatedValue );
		}
	}
	
	const selectStyle = [
		ThemedSelectStyles.select,
		style
	]
	
	useEffect( () => {
		onSubmit()
	}, [ option, time1, time2 ] );
	
	useEffect( () => {
		return findSelectedOption();
	}, [ selected ] )
	
	const canShowTimeSelect = _.startsWith( option, 'day' ) || _.startsWith( option, 'week' );

	return (
		<HStack
			spacing={ 6 }
			alignItems="flex-start"
			justifyContent="center">
			
			<View
				style={styles.viewFlex1}>
				
				<VStack>
					<ThemedSelect
						style={ selectStyle }
						placeholder={ placeholder }
						disabled={ disabled }
						options={ options }
						selected={ option ?? '' }
						select={ onSelect.bind( this ) }
					/>

					{ canShowTimeSelect && (
						<Text style={ styles.subText } appearance={'hint'}>{ i18n.t('form.timeslot_time_select.information') }</Text>
					)}
				</VStack>
			</View>
			
			{ canShowTimeSelect && (
				<View
					flex={ 1 }>
					
					<HStack
						alignItems="center"
						justifyContent="center">
						
						<VStack>
							<ThemedTimePicker
								empty={ 'start_time' }
								style={ styles.timePicker }
								time={ time1 }
								onSelect={ onSelectTime1 }
							/>
							<Text style={ styles.subText } appearance={'hint'}>{ i18n.t('form.timeslot_time_select.from') }</Text>
						</VStack>
						
						<VStack>
							<ThemedTimePicker
								empty={ 'start_time' }
								style={ styles.timePicker }
								time={ time2 }
								onSelect={ onSelectTime2 }
							/>
							<Text style={ styles.subText } appearance={'hint'}>{ i18n.t('form.timeslot_time_select.until') }</Text>
						</VStack>
					</HStack>
				</View>
			)}
		</HStack>
	)
}

const styles = StyleSheet.create({
	viewFlex1: {
		flex: 1,
	},
	timePicker: {
		flex: 1,
		minWidth: 130
	},
	
	subText: {
		fontSize: 12
	}
});

export default React.memo( ThemedTimeslotTimeSelect, isEqual );
